export function registerProcoreCanonicalCacheServiceWorker(enabled: boolean | undefined): void {
    // Opt-in: enable from the host app (recommended) or fall back to build-time env.
    if (!enabled && import.meta.env.REACT_APP_ENABLE_PROCORE_CANONICAL_CACHE !== "true") {
        return;
    }

    if (!("serviceWorker" in navigator)) {
        return;
    }

    // Registration is intentionally non-blocking: first load may not be controlled until reload.
    // Once active, subsequent sessions benefit from canonical CacheStorage across signature refresh.
    void navigator.serviceWorker
        .register("/procore-canonical-cache-sw.js", { scope: "/" })
        .catch((e) => console.warn("Failed to register Procore canonical cache service worker:", e));
}
